import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { IWorkbookActions } from '../types/IWorkbookActions';

export class GetWorkbookActionsRequest extends Request<ISingleIdParams, IWorkbookActions> {
  constructor(id: string) {
    super('getWorkbookActions', { id: id });
  }
}
